module.exports = __webpack_public_path__ + "static/img/robot-result.b909707.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/robot-result.png
// module id = C4hZ
// module chunks = 1